import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { $app } from "@app/app.service";

@Component({
    selector: 'page-app-basic',
    template: ''
})
export class AppBasicPage implements OnInit, AfterViewInit, OnDestroy {

    console: boolean = $app.core.modeDevel;
    logPrefix: string = '@page - '+ this.constructor.name;

    $app = $app; //for use in template

    modePage:string = '';

    ngOnInit(): void {

        if(this.console) console.log( this.logPrefix, 'AppBasicPage - init' );
    }

    ngAfterViewInit() {

    }

    ngOnDestroy(){

    }
}


